export default [
    {
        path: 'relatorio-atendimento-odontologico',
        component: () => import(
            '@/views/atencao-basica/relatorio-atendimento-odontologico/Index'
        ),
        redirect: 'relatorio-atendimento-odontologico/index',
        children: [
            {
                name: 'atencao-basica-relatorio-atendimento-odontologico',
                path: 'index',
                component: () => import(
                    '@/views/atencao-basica/relatorio-atendimento-odontologico/List'
                ),
            },
        ],
    },
]